module.exports = __webpack_public_path__ + "static/media/notched.34c6583b.svg";